export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024 * 1024; // 10 GB placeholder

export function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}

export function validateImportRow(file, maxUploadSizeBytes) {
  if (file.size > maxUploadSizeBytes) {
    return {
      validationError: `File exceeds maximum size of ${formatFileSize(maxUploadSizeBytes)}`,
      validationWarning: null,
    };
  }

  if (!file.type.startsWith('video/')) {
    return {
      validationError: null,
      validationWarning: 'This file may not be a supported video format',
    };
  }

  return { validationError: null, validationWarning: null };
}

export function isImportAllEnabled(rows) {
  const importableRows = rows.filter((r) => !r.validationError);
  if (importableRows.length === 0) return false;
  return importableRows.every((r) => r.folderId !== null);
}
